/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @next/next/no-img-element */
/* eslint-disable react/no-unescaped-entities */
// @ts-nocheck
import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import InputForm from '@/components/atoms/input/InputForm'
import * as yup from "yup";
import { handleChangeField, handleChangeSelect } from '@/utility/helper/dataMutation';
import InputSearch from '@/components/atoms/input/inputSearch';
import { icon_list } from '@/assets/images';
import Image from 'next/image';
import useCareerQuery from '@/utility/hooks/apiHooks/useCareer';
import route_list from '@/constant/routeUrl';
import dayjs from 'dayjs';
import { MetaData, PageLoading } from '@/components/atoms';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { getSeoMetadata } from '@/utility/apiProcess/seo/server';

export async function getStaticProps() {
  const locale = 'id'
  let seoMetadata = { data: { result: {} } }
  try {
    seoMetadata = await getSeoMetadata({category_slug: 'pages', names: 'career'})
  } catch (err) {
    console.error('[getStaticProps] getSeoMetadata failed at build time, falling back to {}', err)
  }

  return {
		props: {
      seoMetadata: seoMetadata.data.result || {},
			...(await serverSideTranslations(locale, ['footer', 'navbar', 'career'])),
		},
	}
}

const Career = (props) => {
	const { t } = useTranslation('career')
  const {loadingCareers, careersData, startCareer, careerFieldData, handleSelectedField, careerLocation, isLoading} = useCareerQuery()
	const router = useRouter()
	const [formToState, setFormToState] = useState([
    {
      title: "",
      placeholder: 'Choose Location',
      type: 'select',
      value: '',
      name: 'filter[location]',
      rules: yup.object().required("Influencer is required!").nullable(),
      error: '',
      options: careerLocation,
    },
		{
      title: "",
      placeholder: 'Search Opening Job',
      type: 'text',
      value: '',
      name: 'search',
      rules: yup.object().required("Search Opening is required!").nullable(),
      error: '',
    },
  ])
  const [timer, setTimer] = useState<NodeJS.Timeout | number>(0)

  const handleOnChange = (event:any, targetMutation:any, setTargetMutation:any) => {
    let clone_filter = _.cloneDeep(formToState)
    const targetType = event.target.type
    if(targetType === 'search') {
      clone_filter = handleChangeField(event, targetMutation)
    } else if(targetType === 'select') {
      clone_filter = handleChangeSelect(event, targetMutation)
    }
    setTargetMutation(clone_filter)
    
    clearTimeout(timer)
    const new_time = setTimeout(() => {
      handleFilter(clone_filter, 'filter_data')
    }, 2000)
    
    setTimer(new_time)
  }

  const handleFilter = (params:any = null, type:string) => {
    let filter_data:any = {}
    // let clone_row_pagination = _.cloneDeep(rowsPagination)
    
    if(type === 'filter_data') {
      params.forEach((item:any) => {
        if(item.value) {
          if(_.isObject(item.value) && !_.isDate(item.value)) {
            filter_data[item.name] = item.value.value
          } else if(_.isDate(item.value)) {
            filter_data[item.name] = dayjs(item.value).format('YYYY-MM-DD')
          } else {
            filter_data[item.name] = item.value
          }
        }
      })

      filter_data = _.merge(filter_data)
    } else if(type === 'pagination') {
      _.cloneDeep(filterSearch).forEach((item:any) => {
        if(item.value) {
          filter_data[item.name] = item.value
        }
      })
      filter_data = _.merge(filter_data, params)
    } else {
      let clone_filter = _.cloneDeep(filterSearch)
      clone_filter = clone_filter.map((item:any) => {
        return {
          ...item,
          value: ''
        }
      })
      setFilterSearch(clone_filter)
    }

    // console.log(filter_data)
    startCareer(filter_data)
  }

  useEffect(() => {
    if(!_.isEmpty(careerLocation)) {
      const cloneFormToState = _.cloneDeep(formToState)
      cloneFormToState[0].options = careerLocation
      setFormToState(cloneFormToState)
    }
  }, [careerLocation])

  // useEffect(() => {
  //   window.fbq('track', 'VisitPage', {content_name: 'Career Page'})
  // }, [])


  if(loadingCareers) {
    return <PageLoading />
  }

	return (
		<div className='tw-bg-gradient-to-r tw-from-dark-green tw-to-light-green tw-w-full'>
      <MetaData title={props.seoMetadata.title} ogImage="https://i.ibb.co/bzC5z1g/socialbreadlogo.jpg" ogTitle={props.seoMetadata.title} keywords={props.seoMetadata.keywords} ogDescription={props.seoMetadata.description} />
			<div className='tw-newsroom-banner' id='newsroom-banner'>
				<div className='tw-m-auto md:tw-py-16 tw-py-8 tw-px-4 tw-max-w-6xl tw-mx-auto'>
					<h2 className='tw-text-white md:tw-text-5xl tw-text-2xl tw-font-bold tw-mb-5 tw-pb-1'>
						{t('career.title')}
					</h2>
					<span className='tw-text-white tw-text-sm tw-text-justify tw-flex'>
						{t('career.description')}
					</span>
				</div>
			</div>
			<div className='tw-w-full tw-min-h-[500px] tw-flex tw-items-center tw-justify-center tw-flex-col tw-bg-[#F1F1F1] md:tw-rounded-[40px] tw-rounded-[20px]'>
        <div className='tw-max-w-6xl tw-mx-auto md:tw-mt-10 md:tw-mb-32 md:px-0 md:py-0 tw-text-justify tw-px-4 tw-py-6 tw-w-full'>
          <h1 className='md:tw-text-6xl tw-pb-1 tw-text-2xl tw-font-bold tw-mb-10 tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-dark-green tw-from-20% tw-to-light-green tw-to-40%'>{t('career.job_open')}</h1>
          <div className='tw-flex md:tw-flex-row tw-flex-col-reverse tw-mb-10 tw-gap-4'>
            <div className='tw-grid tw-w-full'>
              <InputForm 
                formData={formToState.slice(0, 1)}
                onChange={handleOnChange}
                targetMutation={formToState}
                setTargetMutation={setFormToState}
                containerStyle='tw-grid md:tw-grid-cols-2 tw-grid-cols tw-gap-4 md:tw-w-[400px]'
              />
            </div>
            <div className='tw-flex tw-justify-end md:tw-w-[500px] md:mt-0'>
              <InputSearch value={formToState[1].value} name={formToState[1].name} placeholder={formToState[1].placeholder} onChange={e => handleOnChange(e, formToState, setFormToState)}/>
            </div>
          </div>
          <div className='tw-grid md:tw-grid-cols-3'>
            <div className='md:tw-block tw-hidden'>
              <h1 className=' tw-text-xl tw-text-light-green tw-font-medium'>{t('career.dep')}</h1>
              <ul className=' tw-flex tw-flex-col tw-gap-3 tw-font-semibold tw-text-dark-green tw-py-3'>
                {careerFieldData?.map((item:any, index:number) => (
                  <li key={`index-field-${index}`} className={item.isSelected ? 'tw-font-extrabold tw-border-l-2 tw-border-dark-green tw-pl-3' : ''}>
                    <button onClick={() => handleSelectedField(index, formToState, handleFilter)}>{item.label}</button>
                  </li>
                ))}
              </ul>
            </div>
            <div className='md:tw-col-span-2'>
              <h1 className=' tw-text-xl tw-text-light-green tw-font-medium tw-mb-3'>{t('career.feat')}</h1>
              <div className='tw-flex tw-flex-col tw-gap-5'>
                {careersData.length === 0 && (<div>Data tidak di Temukan</div>)}
                {careersData?.map((item:any, index:number) => (
                  <button onClick={() => router.push(route_list.careerDetail(item.slug))} key={`job-section-${index}`} className="tw-flex tw-flex-row tw-items-center tw-bg-white tw-p-4 tw-rounded-xl tw-text-left">
                    <div className="tw-mr-auto tw-w-full">
                      <h5 className="tw-mb-3 tw-text-xl tw-font-bold tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-dark-green tw-to-light-green">{item.title}</h5>
                      <p className="tw-text-neutral-500">
                        {item.location}
                      </p>
                    </div>
                    <Image src={icon_list.next_gradient_green} alt="" className="tw-w-8 tw-h-8 tw-mt-2 md:tw-mt-0"/>
                  </button>
                ))}
              </div>
            </div>
          </div>

        </div>
			</div>
		</div>
	)
}

export default Career

 